function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { buildComponentName } from '../utils';
import SubMixin from './mixins/sub';
import Icon from '../icon';
import Checkbox from '../checkbox';
import Dropdown from '../dropdown';
import { UxMenu, UxMenuItem as MenuItem } from '../menu';
var defaultSelections = [{
  key: 'all',
  text: '全选当页',
  isDefault: true,
  onSelect: function onSelect() {}
}, {
  key: 'invert',
  text: '反选当页',
  isDefault: true,
  onSelect: function onSelect() {}
}];
var __vue_script__ = {
  name: buildComponentName('SelectionCheckboxAll'),
  components: {
    Checkbox: Checkbox,
    Dropdown: Dropdown,
    Icon: Icon,
    UxMenu: UxMenu,
    MenuItem: MenuItem
  },
  mixins: [SubMixin],
  props: {
    dropdownPrefixCls: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selections: {
      type: [Array, Boolean],
      default: false
    },
    hideDefaultSelections: {
      type: Boolean,
      default: false
    },
    getPopupContainer: {
      type: Function,
      default: function _default() {}
    }
  },
  computed: {
    boxPrefixCls: function boxPrefixCls() {
      return "".concat(this.prefixCls, "-selection");
    },
    classes: function classes() {
      var boxPrefixCls = this.boxPrefixCls;
      return _defineProperty({}, boxPrefixCls, true);
    },
    boxClasses: function boxClasses() {
      var boxPrefixCls = this.boxPrefixCls,
          normalizeSelections = this.normalizeSelections;
      return _defineProperty({}, "".concat(boxPrefixCls, "-select-all-custom"), normalizeSelections.length > 0);
    },
    normalizeSelections: function normalizeSelections() {
      var selections = this.selections,
          hideDefaultSelections = this.hideDefaultSelections;
      var dSelections = hideDefaultSelections ? [] : defaultSelections;
      var ret = [];

      if (selections) {
        if (Array.isArray(selections)) {
          ret = [].concat(_toConsumableArray(dSelections), _toConsumableArray(selections));
        } else {
          ret = dSelections;
        }
      }

      return ret;
    },
    checked: function checked() {
      var data = this.data,
          selectedRowKeys = this.selectedRowKeys;
      return data.length > 0 && data.every(function (v) {
        return selectedRowKeys.indexOf(v.$$_key) > -1;
      });
    },
    indeterminate: function indeterminate() {
      var selectedRowKeys = this.selectedRowKeys,
          data = this.data;
      var some = data.some(function (v) {
        return selectedRowKeys.indexOf(v.$$_key) > -1;
      });
      var every = data.every(function (v) {
        return selectedRowKeys.indexOf(v.$$_key) > -1;
      });
      return !every && some;
    }
  },
  methods: {
    onChange: function onChange(e) {
      var checked = e.target.checked;
      this.$emit('change', checked ? 'all' : 'removeAll');
    },
    onMenuItemClick: function onMenuItemClick(selection) {
      var key = selection.key,
          _selection$isDefault = selection.isDefault,
          isDefault = _selection$isDefault === void 0 ? false : _selection$isDefault,
          onSelect = selection.onSelect;
      this.$emit('change', key, onSelect, isDefault);
    }
  }
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.classes
  }, [_c('checkbox', {
    class: _vm.boxClasses,
    attrs: {
      "checked": _vm.checked,
      "disabled": _vm.disabled,
      "indeterminate": _vm.indeterminate
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm.normalizeSelections.length > 0 ? _c('dropdown', {
    attrs: {
      "theme": _vm.theme,
      "get-popup-container": _vm.getPopupContainer
    }
  }, [_c('div', {
    class: _vm.boxPrefixCls + "-down",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('icon', {
    attrs: {
      "type": "down"
    }
  })], 1), _c('div', {
    class: _vm.boxPrefixCls + "-dropdown",
    attrs: {
      "slot": "overlay"
    },
    slot: "overlay"
  }, [_c('ux-menu', {
    attrs: {
      "prefix-cls": _vm.dropdownPrefixCls + "-menu",
      "selected-keys": [],
      "mode": "vertical"
    }
  }, _vm._l(_vm.normalizeSelections, function (selection, i) {
    return _c('menu-item', {
      key: i,
      attrs: {
        "name": selection.key || i
      }
    }, [_c('div', {
      on: {
        "click": function click($event) {
          return _vm.onMenuItemClick(selection);
        }
      }
    }, [_vm._v(" " + _vm._s(selection.text) + " ")])]);
  }), 1)], 1)]) : _vm._e()], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "checkboxAll.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  if (false) {
    var hook;

    if (false) {
      // In SSR.
      hook = function hook(context) {
        // 2.3 injection
        context = context || // cached call
        this.$vnode && this.$vnode.ssrContext || // stateful
        this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
        // 2.2 with runInNewContext: true

        if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
          context = __VUE_SSR_CONTEXT__;
        } // inject component styles


        if (style) {
          style.call(this, createInjectorSSR(context));
        } // register component module identifier for async chunk inference


        if (context && context._registeredComponents) {
          context._registeredComponents.add(moduleIdentifier);
        }
      }; // used by ssr in case component is cached and beforeCreate
      // never gets called


      component._ssrRegister = hook;
    } else if (style) {
      hook = shadowMode ? function (context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
      } : function (context) {
        style.call(this, createInjector(context));
      };
    }

    if (hook !== undefined) {
      if (component.functional) {
        // register for functional component in vue file
        var originalRender = component.render;

        component.render = function renderWithStyleInjection(h, context) {
          hook.call(context);
          return originalRender(h, context);
        };
      } else {
        // inject component registration as beforeCreate hook
        var existing = component.beforeCreate;
        component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
      }
    }
  }

  return component;
}
/* style inject */

/* style inject SSR */

/* style inject shadow dom */


var __vue_component__ = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;